import { Component } from 'react';
import { connect } from 'react-redux';
import ImportExportView from '../../components/import-export-view/ImportExportView.jsx';

// eslint-disable-next-line
class ImportExport extends Component {
    render() {
        return <ImportExportView />;
    }
}

export default connect()(ImportExport);
